import i18next from 'i18next'
import { CSSProperties } from 'react'
import { getWarningLineColor } from '../../blocks/common'
import { Tooltip } from '@/ui'

export function ExitNode(props: {
  style?: CSSProperties
  uiHandle?: boolean
  warningText?: string
  warningDescText?: string
}) {
  return (
    <section
      className="relative z-[2] flex size-fit min-w-[69px] items-center justify-center rounded-full border-2 border-border-brand bg-fg-primary px-3 py-2.5 shadow-md hover:z-[3]"
      style={{
        ...props.style,
        borderColor: props.warningText ? getWarningLineColor() : '',
      }}
    >
      <p className="text-[14px] font-semibold text-text-secondary">{i18next.t('campaign.block.exit')}</p>

      {props.warningText && (
        <>
          {props.uiHandle !== false && (
            <div
              style={{ transform: 'translate(-50%, 0)', clipPath: 'polygon(0 0, 100% 0, 100% 50%, 0 50%)' }}
              className="pointer-events-none absolute left-1/2 top-[-11px] size-5 rounded-full border-2 border-border-warning bg-transparent"
            />
          )}
          <Tooltip message={props.warningText + '. ' + props.warningDescText}>
            <div className="absolute right-[-12px] flex size-[24px] items-center justify-center rounded-full border-2 border-border-warning bg-fg-primary text-[19px] font-semibold text-text-secondary">
              <span>!</span>
            </div>
          </Tooltip>
        </>
      )}
    </section>
  )
}
